module.exports = __webpack_public_path__ + "img/communityadminpainpoint3.d92e010d.png";